import { useState, useCallback } from 'react';
import { addUnifyStore } from '@services/unify';
import { useShop } from './useShop';

// NEA-5838 — drives the "Add another store" flow: POSTs to /api/billing/add-store,
// refreshes the shops cache so the new store is immediately routable, and returns
// the created shop so the caller can navigate into its onboarding.
export function useAddStore() {
	const { mutate } = useShop();
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	const addStore = useCallback(
		async (sourceShopId, shopData) => {
			setLoading(true);
			setError(null);
			try {
				const { shop } = await addUnifyStore(sourceShopId, shopData);
				await mutate();
				return shop;
			} catch (err) {
				setError(err.response?.data?.message || 'Failed to add store. Please try again.');
				throw err;
			} finally {
				setLoading(false);
			}
		},
		[mutate]
	);

	return { addStore, loading, error };
}
